import { ChangeDetectorRef, Injectable, Input } from '@angular/core';
import { ConstantProvider } from './constant.provider';
import { SettingService } from 'app/modules/admin/setting/service/setting.service';
import { Subject, takeUntil } from 'rxjs';
@Injectable({
    providedIn: 'root',
})

export class ChartBuilderProvider {

    constructor(private constants: ConstantProvider,
        private settinService: SettingService) {
        this.getWordCoin();
    }
    public word_coin: string = '';
    private unsubscribeAll: Subject<any> = new Subject<any>();

    public formatLabel(str, maxwidth) {
        var sections = [];
        var words = str.split(" ");
        var temp = "";
        var seriesLabel = '';

        words.forEach(function (item, index) {
            if (temp.length > 0) {
                var concat = temp + ' ' + item;

                if (concat.length > maxwidth) {
                    sections.push(temp);
                    temp = "";
                }
                else {
                    if (index == (words.length - 1)) {
                        sections.push(concat);
                        return;
                    }
                    else {
                        temp = concat;
                        return;
                    }
                }
            }

            if (index == (words.length - 1)) {
                sections.push(item);
                return;
            }

            if (item.length < maxwidth) {
                temp = item;
            }
            else {
                sections.push(item);
            }

        });

        sections.forEach(str => {
            seriesLabel = seriesLabel + '\n' + str;
        });

        return seriesLabel;
    }

    buildDoughnutChart(data = [], labels = [], color, events) {
        const options = {
            chart: {
                animations: {
                    speed: 400,
                    animateGradually: {
                        enabled: false
                    }
                },
                events,
                fontFamily: 'inherit',
                foreColor: 'inherit',
                height: '90%',
                type: 'donut',
                sparkline: {
                    enabled: true
                }
            },
            labels: labels,
            plotOptions: {
                pie: {
                    customScale: 0.9,
                    expandOnClick: false,
                    donut: {
                        size: '70%'
                    }
                }
            },
            series: data,
            states: {
                hover: {
                    filter: {
                        type: 'none'
                    }
                },
                active: {
                    filter: {
                        type: 'none'
                    }
                }
            },
            theme: {
                monochrome: {
                    enabled: true,
                    color: color
                }
            },
            tooltip: {
                enabled: true,
                fillSeriesColor: false,
                theme: 'dark',
                y: {
                    formatter: function (value) {
                        return value.toString() + '%';
                    }
                }
                // custom         : ({
                //                     seriesIndex,
                //                     w
                //                 }): string => `<div class="flex items-center h-8 min-h-8 max-h-8 px-3">
                //                                     <div class="w-3 h-3 rounded-full" style="background-color: ${w.config.colors[seriesIndex]};"></div>
                //                                     <div class="ml-2 text-md leading-none">${w.config.labels[seriesIndex]}:</div>
                //                                     <div class="ml-2 text-md font-bold leading-none">${w.config.series[seriesIndex]}%</div>
                //                                 </div>`
            }
        };
        return options;
    }

    buildColoredDoughnutChart(data = [], labels = [], colors = [], legenedPosition = "top", data_in_donut = false) {
        const options = {
            chart: {
                animations: {
                    speed: 400,
                    animateGradually: {
                        enabled: false
                    }
                },
                fontFamily: 'inherit',
                foreColor: 'inherit',
                height: '90%',
                type: 'donut',
                if(data_in_donut) {
                    sparkline: {
                        enabled: true
                    }
                }
            },
            legend: {
                show: true,
                position: legenedPosition,
                // offsetY: 8,
                // markers: {
                //     width: 15,
                //     height: 5,
                //     strokeWidth: 0,
                // },
            },
            labels: labels,
            plotOptions: {
                pie: {
                    customScale: 0.9,
                    expandOnClick: true,
                    donut: {
                        // size: 175,
                        size: '40%',
                        labels: {
                            show: true,
                        },
                    }
                }
            },
            series: data,
            states: {
                hover: {
                    filter: {
                        type: 'none'
                    }
                },
                active: {
                    filter: {
                        type: 'none'
                    }
                }
            },
            colors: colors,
            tooltip: {
                enabled: true,
                fillSeriesColor: false,
                theme: 'dark',
                y: {
                    formatter: function (value) {
                        return value.toString();
                    }
                }
            },
            // responsive: [
            //     {
            //         breakpoint: 480,
            //         options: {
            //             chart: {
            //                 width: 200
            //             },
            //             legend: {
            //                 position: "bottom"
            //             }
            //         }
            //     }
            // ]
        };
        return options;
    }

    buildColumnChart(data = [], labels = [], color, formatterString = "", labelPosition = "top") {
        const options = {
            series: [{
                name: '',
                data: data
            }],
            chart: {
                height: 250,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    borderRadius: 2,
                    dataLabels: {
                        position: labelPosition, // top, center, bottom
                    },
                }
            },
            grid: {
                show: false
            },
            fill: {
                colors: [color]
            },
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                    return val + formatterString;
                },
                offsetY: labelPosition == "top" ? -20 : 0,
                style: {
                    fontSize: '12px',
                    colors: ["#304758"]
                }
            },
            xaxis: {
                categories: labels,
                position: 'bottom',
                axisBorder: {
                    show: true
                },
                axisTicks: {
                    show: true
                },
                tooltip: {
                    enabled: false,
                },
            },
            yaxis: {
                axisBorder: {
                    show: true
                },
                axisTicks: {
                    show: true,
                },
                labels: {
                    show: true,
                    formatter: function (val) {
                        return val + formatterString;
                    }
                },
                max: Math.max(...data) + 1
            },
            tooltip: {
                enabled: true,
                fillSeriesColor: false,
                // theme: 'dark',
                y: {
                    formatter: function (value) {
                        return value.toFixed(2).toString() + formatterString;
                    }
                }
            }
        };

        return options;
    }

    buildBarChart(data = [], labels = [], color, chartTitle = "", formatterString = "") {
        const options = {
            series: [{
                name: '',
                data: data
            }],
            chart: {
                height: 250,
                type: 'bar',
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    borderRadius: 2,
                    dataLabels: {
                        position: 'top', // top, center, bottom
                    },
                }
            },
            grid: {
                show: false
            },
            fill: {
                colors: [color]
            },
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                    return val + formatterString;
                },
                offsetX: 30,
                style: {
                    // fontSize: '12px',
                    colors: ["#304758"]
                }
            },
            xaxis: {
                categories: labels,
                position: 'bottom',
                axisBorder: {
                    show: true
                },
                axisTicks: {
                    show: true
                },
                labels: {
                    show: true,
                    // formatter: function (val) {
                    //     return val + formatterString;
                    // }
                },
                tooltip: {
                    enabled: false,
                },
                max: Math.max(...data) + 1
            },
            yaxis: {
                title: {
                    text: chartTitle,
                    offsetX: 7,
                },
                axisBorder: {
                    show: true
                },
                axisTicks: {
                    show: true,
                },
                labels: {
                    show: true,
                    // formatter: function (val) {
                    //     return val + formatterString;
                    // }
                }
            },
            tooltip: {
                enabled: true,
                fillSeriesColor: false,
                // y: {
                //     formatter: function (value) {
                //         return value.toFixed(2).toString() + formatterString;
                //     }
                // }
            }
        };

        return options;
    }

    buildStackedBarChart(data = [], labels = [], colors = [], chartTitle = "", formatterString = "") {
        const options = {
            series: data,
            chart: {
                height: 510,
                type: 'bar',
                stacked: true
            },
            legend: {
                position: 'top',
                horizontalAlign: 'center',
                // offsetX: 40
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    borderRadius: 2,
                    dataLabels: {
                        // position: 'top', // top, center, bottom
                        total: {
                            enabled: true,
                            offsetX: 0,
                            style: {
                                fontSize: '13px',
                                fontWeight: 900,
                            }
                        }
                    },
                }
            },
            grid: {
                show: false
            },
            colors: colors,
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                    return val + formatterString;
                },
                enabledOnSeries: true,
                // offsetX: 30,
                // style: {
                //     // fontSize: '12px',
                //     colors: ["#304758"]
                // }
            },
            xaxis: {
                categories: labels,
                // position: 'bottom',
                axisBorder: {
                    show: true
                },
                axisTicks: {
                    show: true
                },
                labels: {
                    show: true,
                    // formatter: function (val) {
                    //     return val + formatterString;
                    // }
                },
                tooltip: {
                    enabled: false,
                }
            },
            yaxis: {
                title: {
                    text: chartTitle,
                    // offsetX: 7,
                },
                axisBorder: {
                    show: true
                },
                axisTicks: {
                    show: true,
                },
                labels: {
                    show: true,
                    // formatter: function (val) {
                    //     return val + formatterString;
                    // }
                }
            },
            tooltip: {
                enabled: true,
                fillSeriesColor: false,
                // y: {
                //     formatter: function (value) {
                //         return value.toFixed(2).toString() + formatterString;
                //     }
                // }
            }
        };

        return options;
    }

    radialBar(data = [], points: any, dataColor: any) {

        const options = {

            series: data,
            chart: {
                height: 250,
                type: "radialBar"
            },
            labels: [this.word_coin.length > 10 ? this.word_coin.substring(0, 10) + "..." : this.word_coin],
            plotOptions: {
                radialBar: {

                    dataLabels: {

                        show: true,
                        name: {
                            offsetY: 35,
                            show: true,
                            color: 'black',
                            fontSize: "15px"

                        },

                        value: {
                            formatter: function (value) {
                                return points;
                            },
                            color: dataColor,
                            fontSize: "40px",
                            show: true,
                            offsetY: -15,
                            style: {

                            }
                        }

                    }

                }
            },
            fill: { colors: [dataColor] },
            tooltip: {
                enabled: true,
                fillSeriesColor: false,
                theme: 'dark',
                y: {
                    formatter: function (value) {
                        return value.toString();
                    }
                }
            }



        }
        return options;
    }

    getWordCoin(): void {
        this.settinService.setting$.pipe(takeUntil(this.unsubscribeAll)).subscribe((res) => {
            this.word_coin = res.word_coin;
            //console.log(res);

        })
    }

    radialBarMarketplace(data = [], size: number, points: number) {
        const options = {

            series: data,
            chart: {
                height: size,
                type: "radialBar",
            },
            plotOptions: {
                radialBar: {

                    dataLabels: {
                        show: true,
                        name: {
                            offsetY: 25,
                            show: true,
                            color: "#FFFBEB",
                            fontSize: "11px"
                        },

                        value: {
                            formatter: function (val) {
                                return points.toString();
                            },
                            color: "#FFFBEB",
                            fontSize: "28px",
                            show: true,
                            offsetY: -15,
                            style: {
                            }
                        }
                    }

                }
            },
            fill: {
                colors: ['#FBBF24']
            },

            labels: [this.word_coin.length > 10 ? this.word_coin.substring(0, 10) + "..." : this.word_coin]
        }
        return options;
    }

    buildColoredDoughnutCharttrivia(data = [], labels = [], colors = [], legenedPosition = "top") {
        const options = {
            series: data,
            chart: {
                animations: {
                    speed: 400,
                    animateGradually: {
                        enabled: false
                    }
                },
                width: '100%',
                fontFamily: 'inherit',
                foreColor: 'inherit',
                height: '90%',
                type: 'donut',
                // sparkline: {
                //     enabled: true
                // }
            },
            legend: {
                show: true,
                position: legenedPosition,
                // offsetY: 8,
                // markers: {
                //     width: 15,
                //     height: 5,
                //     strokeWidth: 0,
                // },
            },
            labels: labels,
            // responsive: [
            //     {
            //         breakpoint: 480,
            //         options: {
            //             chart: {
            //                 width: 200
            //             },
            //             legend: {
            //                 position: "bottom"
            //             }
            //         }
            //     }
            // ],
            plotOptions: {
                pie: {
                    customScale: 0.9,
                    expandOnClick: true,
                    donut: {
                        // size: 175,
                        size: '50%',
                        labels: {
                            show: true,
                        },
                    }
                }
            },
        };
        return options;
    }

    // buildColoredbarCharttrivia(data = [], labels = [], color = [], chartTitle = "", formatterString = "") {
    //     const options = {
    //         series: [{
    //             name: '',
    //             data: data
    //         }],
    //         chart: {
    //             height: 300,
    //             with: '100%',
    //             type: 'bar',
    //         },
    //         plotOptions: {
    //             bar: {
    //                 horizontal: false,
    //                 borderRadius: 2,
    //                 dataLabels: {
    //                     position: 'top', // top, center, bottom
    //                 },
    //             }
    //         },
    //         grid: {
    //             show: false
    //         },
    //         fill: {
    //             colors: color
    //         },
    //         dataLabels: {
    //             enabled: true,
    //             formatter: function (val) {
    //                 return val + formatterString;
    //             },
    //             offsetX: 30,
    //             style: {
    //                 // fontSize: '12px',
    //                 colors: color
    //             }
    //         },
    //         xaxis: {
    //             categories: labels,
    //             position: 'bottom',
    //             axisBorder: {
    //                 show: true
    //             },
    //             axisTicks: {
    //                 show: true
    //             },
    //             labels: {
    //                 show: true,
    //                 // formatter: function (val) {
    //                 //     return val + formatterString;
    //                 // }
    //             },
    //             tooltip: {
    //                 enabled: false,
    //             },
    //             max: Math.max(...data) + 1
    //         },
    //         yaxis: {
    //             show: false,
    //             title: {
    //                 text: chartTitle,
    //                 offsetX: 7,
    //             },
    //             axisBorder: {
    //                 show: true
    //             },
    //             axisTicks: {
    //                 show: true,
    //             },
    //             labels: {
    //                 show: true,
    //                 // formatter: function (val) {
    //                 //     return val + formatterString;
    //                 // }
    //             }
    //         },
    //         tooltip: {
    //             enabled: true,
    //             fillSeriesColor: false,
    //             // y: {
    //             //     formatter: function (value) {
    //             //         return value.toFixed(2).toString() + formatterString;
    //             //     }
    //             // }
    //         }
    //     };

    //     // console.log(options);


    //     return options;
    // }

    public buildColoredbarCharttrivia(data = [], labels = [], color = []) {
        
        // let users = []
        // let scores = []
        // for (let i = 0; i < bar_graphic.length; i++) {
        //     users.push(bar_graphic[i].user_fullname);
        //     scores.push(bar_graphic[i].final_score);
        // }
        const options = {
            series: [
                {
                    name: "",
                    data: data,
                    backgroundColor: color
                }
            ],
            chart: {
                toolbar: {
                    show: false,
                },
                height: 300,
                // width: 400,
                color: color,
                // width: window.innerWidth,
                type: "bar",
            },
            colors: color,
            plotOptions: {
                bar: {
                    distributed: true,
                    columnWidth: "25%",
                    borderRadius: 10,
                    dataLabels: {
                        position: 'top', // top, center, bottom
                    },
                },
            },
            // stroke:{width:0},
            dataLabels: {
                enabled: true,
                formatter: function (val) {
                  return val + "%";
                },
                offsetY: -20,
                style: {
                  fontSize: '12px',
                  colors: ["#304758"]
                }
            },
            legend: {
                color: color,
                show: false
            },
            grid: {
                show: false
            },
            xaxis: {
                show: false,
                categories: labels,
                // color: color,
                labels: {
                    style: {
                        // colors: color,
                        fontSize: "10px"
                    },
                    formatter: function(val) { 
                        return val;                       
                        // if(val.length > 0)
                        //     return val.substring(0, 15) + '...';
                        // else
                        //     return val;
                    },
                    rotate: -70,
                }
            },
            yaxis: {
                show: false,
                min: 0,
                // max: 100,
                // tickAmount: 10
            },
            fill: color
        };

        return options
    }

    radialBarHome(data = [], dataColor: any) {

        const options = {

            series: data,
            chart: {
                height: 250,
                type: "radialBar"
            },
            labels: [this.word_coin.length > 10 ? this.word_coin.substring(0, 10) + "..." : this.word_coin],
            plotOptions: {
                radialBar: {

                    dataLabels: {

                        show: true,
                        name: {
                            offsetY: 35,
                            show: true,
                            color: 'black',
                            fontSize: "15px"

                        },

                        value: {
                            formatter: function (val) {
                                return '<img src="https://plug-erwp-media.fra1.digitaloceanspaces.com/local/games/TWljcm9zb2Z0VGVhbXMtaW1hZ2UgKDEpIC0gY29waWE.jpg" alt="" class="rounded-full object-cover p-1" style="height: 100%; width: 100%;">';
                            },
                            color: dataColor,
                            fontSize: "40px",
                            show: true,
                            offsetY: -15,
                            style: {

                            }
                        }

                    }

                }
            },
            fill: { colors: [dataColor] },
            tooltip: {
                enabled: true,
                fillSeriesColor: false,
                theme: 'dark',
                // y: {
                //     formatter: function (value) {
                //         return value.toString();
                //     }
                // }
            }

        }
        return options;
    }

}
